import { render, staticRenderFns } from "./ModalVincularEdital.vue?vue&type=template&id=0d5148c8&scoped=true"
import script from "./ModalVincularEdital.vue?vue&type=script&lang=js"
export * from "./ModalVincularEdital.vue?vue&type=script&lang=js"
import style0 from "./ModalVincularEdital.vue?vue&type=style&index=0&id=0d5148c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5148c8",
  null
  
)

export default component.exports